import {fragments} from "@common/react/fragments";
import {OnMounted} from "@common/react/on-mounted";
import {isDev} from "../../tools/dev/is-dev";

const posthogConfig = {
    apiKey: "phc_hZInxUjkociIOpGOm95RafyvrZ6lGR0DUCoOIjnVJUG",
    // managed reverse proxy domain
    apiHost: "https://kd8xap.ad-reporting.net",
    // needed because we go through a proxy, so links point back to PostHog properly
    uiHost: "https://us.posthog.com",
};

// official PostHog web install snippet - loads /static/array.js and queues calls made before it lands.
// keep verbatim, do not hand-edit.
const loadPosthogSnippet = () => {
    // prettier-ignore
    // eslint-disable-next-line
    !function(t,e){var o,n,p,r;e.__SV||(window.posthog && window.posthog.__loaded)||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(".");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}p||((p=t.createElement("script")).type="text/javascript",p.crossOrigin="anonymous",p.async=!0,p.src=s.api_host.replace(".i.posthog.com","-assets.i.posthog.com")+"/static/array.js",p.onerror=function(){p=null},(r=t.getElementsByTagName("script")[0]).parentNode.insertBefore(p,r));var u=e;for(void 0!==a?u=e[a]=[]:a="posthog",u.people=u.people||[],u.toString=function(t){var e="posthog";return"posthog"!==a&&(e+="."+a),t||(e+=" (stub)"),e},u.people.toString=function(){return u.toString(1)+".people (stub)"},o="fo po init Fo Oo qo Zs Lo Bo Ro capture Do vo Go calculateEventProperties Vo register register_once register_for_session unregister unregister_for_session Ko Ao Zo getFeatureFlag getFeatureFlagPayload getFeatureFlagResult getAllFeatureFlags isFeatureEnabled reloadFeatureFlags updateFlags updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures on onFeatureFlags onSurveysLoaded onSessionId getSurveys getActiveMatchingSurveys renderSurvey displaySurvey cancelPendingSurvey canRenderSurvey canRenderSurveyAsync Yo identify setPersonProperties unsetPersonProperties group resetGroups setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags reset Xo shutdown setIdentity clearIdentity get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted captureException addExceptionStep captureLog startExceptionAutocapture stopExceptionAutocapture loadToolbar get_property getSessionProperty Qo Uo createPersonProfile setInternalOrTestUser Jo Eo il opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing get_explicit_consent_status is_capturing clear_opt_in_out_capturing Ho debug Js mn getPageViewId captureTraceFeedback captureTraceMetric Co".split(" "),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);
};

const initPosthog = ({iframeKeyName, collectionId, apiKey, collection}) => {
    if (window.posthog?.__loaded) {
        return;
    }

    loadPosthogSnippet();


    window.posthog.init(posthogConfig.apiKey, {
        api_host: posthogConfig.apiHost,
        ui_host: posthogConfig.uiHost,
        defaults: "2026-05-30",
        // or 'always' to create profiles for anonymous users as well
        person_profiles: "identified_only",
        session_recording: {
            // the dashboard runs inside a cross-origin iframe on the host page
            recordCrossOriginIframes: true,
        },
        loaded: (posthog) => {
            posthog.debug(!!isDev());
            // posthog.debug(true);

            posthog.register({
                verb_iframe_key: apiKey,
                verb_iframe_key_name: iframeKeyName,
                verb_collection_id: collectionId,
                verb_collection_id_redirect: collection.id,
                verb_collection_name: collection.name,
            });
        },
    });
};

export const loadPosthog = ({next, ...params}) => PosthogRoot({next, ...params});

export const PosthogRoot = ({next, ...params}) =>
    fragments(
        next(),

        OnMounted({
            action: () => initPosthog(params),
        })
    );
